import { IconWrapper } from '../runtime';
export default IconWrapper('paperclip', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.81066 1.66614L2.39124 6.08556C0.536253 7.94055 0.536252 10.9481 2.39124 12.8031C4.24623 14.6581 7.25377 14.6581 9.10876 12.8031L14.0585 7.85332C15.3277 6.58412 15.3277 4.52633 14.0585 3.25713C12.7893 1.98792 10.7315 1.98792 9.46231 3.25713L4.51256 8.20688C3.82915 8.89029 3.82915 9.99833 4.51256 10.6817C5.19598 11.3652 6.30402 11.3652 6.98744 10.6817L10.3462 7.32299",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});